import { Repeat, ShoppingBag, Sparkles } from "lucide-react"

import { STATUS_LABELS, fmtCurrency } from "@/lib/propostas"
import { cn } from "@/lib/utils"
import type { ModalidadeProposta, StatusProposta } from "@/types/comercial"

const STATUS_TONE: Record<StatusProposta, string> = {
  rascunho: "text-[hsl(225_6%_70%)] bg-[hsl(228_8%_14%)] [--dot:hsl(225_6%_55%)]",
  enviada: "text-[hsl(224_100%_80%)] bg-[hsl(224_70%_16%)] [--dot:hsl(224_100%_66%)]",
  aceita: "text-[hsl(152_60%_68%)] bg-[hsl(152_45%_12%)] [--dot:hsl(152_60%_52%)]",
  recusada: "text-[hsl(358_90%_76%)] bg-[hsl(358_45%_15%)] [--dot:hsl(358_82%_62%)]",
  vencida: "text-[hsl(38_92%_72%)] bg-[hsl(38_45%_13%)] [--dot:hsl(38_92%_62%)]",
}

export function StatusPill({ status, className }: { status: StatusProposta; className?: string }) {
  return (
    <span className={cn("inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-[11px] font-medium", STATUS_TONE[status], className)}>
      <span className="h-1.5 w-1.5 rounded-full bg-[var(--dot)]" />
      {STATUS_LABELS[status]}
    </span>
  )
}

const MODALIDADE_ICON = { compra: ShoppingBag, locacao: Repeat, personalizada: Sparkles }

/** Valores de cada modalidade em linhas compactas (usado na listagem). */
export function ModalidadesResumo({ modalidades, escolhida }: { modalidades: ModalidadeProposta[]; escolhida?: string }) {
  return (
    <div className="space-y-1">
      {modalidades.map((m) => {
        const Icon = MODALIDADE_ICON[m.tipo]
        const isEscolhida = escolhida === m.id
        return (
          <div key={m.id} className={cn("flex items-center gap-1.5 text-[12px] tabular-nums", escolhida && !isEscolhida && "opacity-45")}>
            <Icon className="h-3 w-3 shrink-0 text-muted-foreground" />
            <span className="text-muted-foreground">{m.nome}</span>
            <span className="font-medium text-foreground">
              {m.valorUnico > 0 && fmtCurrency(m.valorUnico)}
              {m.valorUnico > 0 && m.valorMensal > 0 && " + "}
              {m.valorMensal > 0 && (
                <span className="text-[hsl(258_100%_82%)]">
                  {fmtCurrency(m.valorMensal)}
                  <span className="font-normal text-muted-foreground">/mês</span>
                </span>
              )}
            </span>
            {isEscolhida && <span className="rounded bg-[hsl(152_45%_12%)] px-1.5 text-[10px] font-medium text-[hsl(152_60%_68%)]">escolhida</span>}
          </div>
        )
      })}
    </div>
  )
}
